import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CitiShopRoutingModule } from './citi-shop-routing.module';
import { CdsModalDialogModule } from '@citi-gcg-173875/citi-common-ui-cds';
import { CitiShopComponent } from './citi-shop.component';
import { CitiShopFaqComponent } from './components/citi-shop-faq/citi-shop-faq.component';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
import { CitiShopSaveComponent } from './components/citi-shop-save/citi-shop-save.component';
import { CitiShopDownloadComponent } from './components/citi-shop-download/citi-shop-download.component';
import { CitiShopProgramComponent } from './components/citi-shop-program/citi-shop-program.component';
import { CitiShopHeaderComponent } from './components/citi-shop-header/citi-shop-header.component';
import { CitiShopAddToBrowserButtonComponent } from './components/citi-shop-add-to-browser-button/citi-shop-add-to-browser-button.component';
import { CitiShopMobileInstructionsComponent } from './components/citi-shop-mobile-instructions/citi-shop-mobile-instructions.component';
import { CitiShopSafariInstructionsComponent } from './components/citi-shop-safari-instructions/citi-shop-safari-instructions.component';
import { CitiShopVideoComponent } from './components/citi-shop-video/citi-shop-video.component';
import { CitiShopSuspendDialogComponent } from './components/citi-shop-suspend-dialog/citi-shop-suspend-dialog.component';
import { CitiShopSpeedbumpDialogComponent } from './components/citi-shop-speedbump-dialog/citi-shop-speedbump-dialog.component';
import { FeatureFlagService } from './utility/feature-flag.service';
import { CitiShopPropsService } from './utility/citi-shop-props.service';
import { NonMerchantSearchComponent } from './components/non-merchant-search/non-merchant-search.component';
import { StaticOffersWallComponent } from './components/static-offers-wall/static-offers-wall.component';
import { CitiShopArticleComponent } from './components/citi-shop-article/citi-shop-article.component';


@NgModule({
  declarations: [
    CitiShopComponent,
    CitiShopFaqComponent,
    CitiShopSaveComponent,
    CitiShopDownloadComponent,
    CitiShopProgramComponent,
    CitiShopHeaderComponent,
    CitiShopAddToBrowserButtonComponent,
    CitiShopMobileInstructionsComponent,
    CitiShopSafariInstructionsComponent,
    CitiShopVideoComponent,
    CitiShopSuspendDialogComponent,
    CitiShopSpeedbumpDialogComponent,
    CitiShopArticleComponent
  ],
  imports: [
    CommonModule,
    CitiShopRoutingModule,
    MktCommonModule,
    CdsModalDialogModule,
    NonMerchantSearchComponent,
    StaticOffersWallComponent
  ],
  providers: [FeatureFlagService, CitiShopPropsService]
})
export class CitiShopModule { }
